// // ===============================
// // BatchExamMasterList.jsx (FULL)
// // ✅ UPDATED as per your request:
// // 1) VendorBranchSelector same style (top)
// // 2) Card UI same like your Batch List:
// //    - Card class: 'card-box height-100-p pd-20 mb-20'
// //    - CardTitle tag='h6' + header icon/text
// //    - Search Input centered inside Card (like sample)
// // ✅ NO OTHER LOGIC CHANGES
// // ===============================

// import React, { useEffect, useState } from 'react';
// import { Card, CardTitle, CardBody, Button, Table, Input } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import useVendorBranch from '../../utils/useVendorBranch';
// import { toast } from 'react-toastify';

// // ✅ import your date formatter
// import { formatDate } from '../../constants/DateFormatter'; // ✅ अपना सही path लगा देना

// const getCaseInsensitive = (obj, key) => {
//   if (!obj || typeof obj !== 'object') return undefined;
//   const foundKey = Object.keys(obj).find(
//     (k) => k.toLowerCase() === String(key).toLowerCase(),
//   );
//   return foundKey ? obj[foundKey] : undefined;
// };

// const normalizeArray = (payload) => {
//   if (!payload) return [];
//   if (Array.isArray(payload)) return payload;

//   const directKeys = [
//     'Data',
//     'data',
//     'List',
//     'list',
//     'Result',
//     'result',
//     'Items',
//     'items',
//   ];

//   for (const k of directKeys) {
//     const v = getCaseInsensitive(payload, k);
//     if (Array.isArray(v)) return v;
//   }

//   const nested1 = getCaseInsensitive(payload, 'data');
//   const nested2 = getCaseInsensitive(payload, 'Data');

//   if (nested1 && typeof nested1 === 'object') {
//     const a = normalizeArray(nested1);
//     if (a.length) return a;
//   }
//   if (nested2 && typeof nested2 === 'object') {
//     const a = normalizeArray(nested2);
//     if (a.length) return a;
//   }

//   return [];
// };

// const extractList = (response) => {
//   if (!response) return [];
//   let list = normalizeArray(response?.data);
//   if (!list.length) list = normalizeArray(response);
//   return Array.isArray(list) ? list : [];
// };

// const BatchExamMasterList = () => {
//   const { user } = useSelector((state) => state.authState);
//   const navigate = useNavigate();

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [errorMessage, setErrorMessage] = useState({});
//   const [list, setList] = useState([]);

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const [search, setSearch] = useState('');
//   const onHandleSearch = (e) => setSearch(e.target.value);

//   const onHandleAdd = () => navigate('/save-batch-exam');

//   const onHandleEdit = async (id) => {
//     try {
//       const res = await apiService.get(
//         `api/BatchExamMaster/GetBatchExamMasterById?id=${id}`,
//       );

//       if (res?.status === true) {
//         const row = Array.isArray(res?.data) ? res.data[0] : res?.data;
//         const row2 = Array.isArray(res?.Data) ? res.Data[0] : res?.Data;

//         const finalRow = row || row2;

//         if (!finalRow) {
//           toast.error('Edit data not found from API');
//           return;
//         }

//         navigate('/save-batch-exam', { state: { ...finalRow } });
//       } else {
//         toast.error(res?.message || 'Failed to load edit data');
//       }
//     } catch (e) {
//       console.error(e);
//       toast.error('Something went wrong (Edit load)');
//     }
//   };

//   const onHandleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete?')) return;

//     try {
//       const res = await apiService.delete(
//         `api/BatchExamMaster/DeleteBatchExamMaster?id=${id}`,
//       );
//       if (res?.status === true) {
//         toast.success(res.message);
//         GetList();
//       } else {
//         toast.error(res?.message || 'Failed');
//       }
//     } catch (e) {
//       console.error(e);
//       toast.error('Something went wrong');
//     }
//   };

//   const GetList = async () => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';
//       const s = search || '';

//       const res = await apiService.get(
//         `api/BatchExamMaster/GetAllBatchExamMaster?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(s)}`,
//       );

//       if (res?.status === true) {
//         const rows = extractList(res);
//         setList(rows);
//       } else {
//         toast.error(res?.message || 'Failed');
//       }
//     } catch (e) {
//       console.error(e);
//       toast.error('Something went wrong');
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad) GetList();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectionData.vendor_id, selectionData.branch_id]);

//   return (
//     <>
//       <div className='d-flex justify-content-end mb-2'>
//         <Button color='primary' onClick={onHandleAdd}>
//           <i className='bi bi-plus-circle' /> Add Batch Exam
//         </Button>
//       </div>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box height-100-p pd-20 mb-20'>
//         <CardTitle
//           tag='h6'
//           className='p-3 mb-0 d-flex align-items-center justify-content-between'
//         >
//           <div className='d-flex align-items-center'>
//             <i className='bi bi-journal-check mr-2'></i> Batch Exam Master List
//           </div>
//         </CardTitle>

//         <div
//           className='col-12 d-flex justify-content-center'
//           style={{ paddingRight: 10, paddingLeft: 10 }}
//         >
//           <Input
//             placeholder='Search...'
//             value={search}
//             onChange={onHandleSearch}
//             className='mx-auto'
//             onKeyDown={(e) => e.key === 'Enter' && GetList()}
//           />
//         </div>

//         <CardBody>
//           <Table striped hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Edit</th>
//                 <th>Delete</th>
//                 <th>Start</th>
//                 <th>End</th>
//                 <th>Published</th>
//               </tr>
//             </thead>
//             <tbody>
//               {list.length > 0 ? (
//                 list.map((x, i) => (
//                   <tr key={x.id}>
//                     <td>{i + 1}</td>

//                     <td>
//                       <i
//                         className='bi bi-pencil text-primary'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onHandleEdit(x.id)}
//                       />
//                     </td>

//                     <td>
//                       <i
//                         className='bi bi-trash text-danger'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onHandleDelete(x.id)}
//                       />
//                     </td>

//                     {/* ✅ DD/MM/YYYY */}
//                     <td>
//                       {formatDate(x.start_date, 'DD-MM-YYYY').replaceAll(
//                         '-',
//                         '/',
//                       )}
//                     </td>
//                     <td>
//                       {formatDate(x.end_date, 'DD-MM-YYYY').replaceAll(
//                         '-',
//                         '/',
//                       )}
//                     </td>

//                     <td>{x.is_published ? 'Yes' : 'No'}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan='8' className='text-center'>
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default BatchExamMasterList;
//SignalR
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Card, CardTitle, CardBody, Button, Table, Input } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import { toast } from 'react-toastify';
import { formatDate } from '../../constants/DateFormatter';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'BatchExamMaster';

const getCaseInsensitive = (obj, key) => {
  if (!obj || typeof obj !== 'object') return undefined;
  const foundKey = Object.keys(obj).find(
    (k) => k.toLowerCase() === String(key).toLowerCase(),
  );
  return foundKey ? obj[foundKey] : undefined;
};

const normalizeArray = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;

  const directKeys = [
    'Data',
    'data',
    'List',
    'list',
    'Result',
    'result',
    'Items',
    'items',
  ];

  for (const k of directKeys) {
    const v = getCaseInsensitive(payload, k);
    if (Array.isArray(v)) return v;
  }

  const nested1 = getCaseInsensitive(payload, 'data');
  const nested2 = getCaseInsensitive(payload, 'Data');

  if (nested1 && typeof nested1 === 'object') {
    const a = normalizeArray(nested1);
    if (a.length) return a;
  }
  if (nested2 && typeof nested2 === 'object') {
    const a = normalizeArray(nested2);
    if (a.length) return a;
  }

  return [];
};

const extractList = (response) => {
  if (!response) return [];
  let list = normalizeArray(response?.data);
  if (!list.length) list = normalizeArray(response);
  return Array.isArray(list) ? list : [];
};

const BatchExamMasterList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [list, setList] = useState([]);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [search, setSearch] = useState('');
  const onHandleSearch = (e) => setSearch(e.target.value);

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const onHandleAdd = () => navigate('/save-batch-exam');

  const onHandleEdit = async (id) => {
    try {
      const res = await apiService.get(
        `api/BatchExamMaster/GetBatchExamMasterById?id=${id}`,
      );

      if (res?.status === true) {
        const row = Array.isArray(res?.data) ? res.data[0] : res?.data;
        const row2 = Array.isArray(res?.Data) ? res.Data[0] : res?.Data;
        const finalRow = row || row2;

        if (!finalRow) {
          toast.error('Edit data not found from API');
          return;
        }

        navigate('/save-batch-exam', { state: { ...finalRow } });
      } else {
        toast.error(res?.message || 'Failed to load edit data');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong (Edit load)');
    }
  };

  const GetList = useCallback(async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';
      const s = search || '';

      // if (!vendorId || !branchId) {
      //   setList([]);
      //   return;
      // }

      const res = await apiService.get(
        `api/BatchExamMaster/GetAllBatchExamMaster?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(s)}`,
      );

      if (res?.status === true) {
        const rows = extractList(res);
        setList(rows);
      } else {
        setList([]);
        toast.error(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
      setList([]);
    }
  }, [selectionData.vendor_id, selectionData.branch_id, search]);

  const onHandleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete?')) return;

    try {
      const res = await apiService.delete(
        `api/BatchExamMaster/DeleteBatchExamMaster?id=${id}`,
      );

      if (res?.status === true) {
        toast.success(res.message || 'Deleted successfully');
        GetList();
      } else {
        toast.error(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) GetList();
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetList,
  ]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectionData.vendor_id || 0;
        const branchId = selectionData.branch_id || 0;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted) return;
          if (!payload) return;

          const isSameModule =
            String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            console.log('BatchExamMaster realtime update received:', payload);
            GetList();
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      setupSignalR();
    }

    return () => {
      mounted = false;
    };
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetList,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, []);

  return (
    <>
      <div className='d-flex justify-content-end mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Batch Exam
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-journal-check mr-2'></i> Batch Exam Master List
          </div>
        </CardTitle>

        <div
          className='col-12 d-flex justify-content-center'
          style={{ paddingRight: 10, paddingLeft: 10 }}
        >
          <Input
            placeholder='Search...'
            value={search}
            onChange={onHandleSearch}
            className='mx-auto'
            onKeyDown={(e) => e.key === 'Enter' && GetList()}
          />
        </div>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Delete</th>
                <th>Start</th>
                <th>End</th>
                <th>Published</th>
              </tr>
            </thead>
            <tbody>
              {list.length > 0 ? (
                list.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>

                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(x.id)}
                      />
                    </td>

                    <td>
                      <i
                        className='bi bi-trash text-danger'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleDelete(x.id)}
                      />
                    </td>

                    <td>
                      {formatDate(x.start_date, 'DD-MM-YYYY').replaceAll('-', '/')}
                    </td>
                    <td>
                      {formatDate(x.end_date, 'DD-MM-YYYY').replaceAll('-', '/')}
                    </td>

                    <td>{x.is_published ? 'Yes' : 'No'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='8' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default BatchExamMasterList;